import { ClockRepo } from '@/modules/working_hours/domain/ClockRepo';
import { Clock } from '@/modules/working_hours/domain/Clock';
import { get_today_secs } from "@/modules/working_hours/domain/Utils";
import { UserRepo } from '@/modules/working_hours/domain/UserRepo';

type ScreenData = {
  username: string;
  user_estado: string;
  ui_hide_btn: 'in' | 'out' | null;
  ui_loading: boolean;
  saludo: string;
  ultimo_fichaje?: string | null;
  last_clock: Clock | null;
  clocks: Clock[];
  estado_texto: string;
  today_string: string;
  timerCounting: number;
};

function startOfToday(now: Date): Date {
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

export class LoadView {
  repo: ClockRepo;
  screen_data: ScreenData;
  timer: any
  timer_ms: number
  user_repo: UserRepo;
  authenticated_user: any;


  constructor(repo: ClockRepo, screen_data: ScreenData, timer:any, timer_ms, user_repo: UserRepo, authenticated_user: any = null) {
    this.repo = repo;
    this.screen_data = screen_data;
    this.timer = timer
    this.timer_ms = timer_ms
    this.user_repo = user_repo
    this.authenticated_user = authenticated_user
  }

  async load() {
    const last = await this.repo.find_last();
    this.screen_data.ui_loading = true;

    try {
      // Si tenemos el usuario autenticado, usarlo directamente
      if (this.authenticated_user && this.authenticated_user.username) {
        this.screen_data.username = this.authenticated_user.username;

        // Intentar obtener el estado del usuario autenticado
        const users = await this.user_repo.find_all();
        const current_user = users.find(u => u.id === this.authenticated_user.id || u.username === this.authenticated_user.username);
        this.screen_data.user_estado = current_user?.estado || 'activo';
      } else {
        // Fallback al comportamiento anterior (tomar el primer usuario)
        const users = await this.user_repo.find_all();
        if (users && users.length > 0) {
          this.screen_data.username = users[0].username;
          this.screen_data.user_estado = users[0].estado || 'activo';
        } else {
          this.screen_data.username = " ";
          this.screen_data.user_estado = 'inactivo';
        }
      }
    } catch (error) {
      this.screen_data.username = " ";
      this.screen_data.user_estado = 'inactivo';
    }



    const opcionesFecha = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' } as const;
    const fechaHoy = new Date();
    const fechaFormateada = fechaHoy.toLocaleDateString('es-ES', opcionesFecha);
    this.screen_data.today_string = fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1);

    if (last) {
      this.screen_data.last_clock = last;

      // ui_hide_btn solo cambia con 'in' y 'out'
      if (last.type === 'in' || last.type === 'continue') {
        this.screen_data.ui_hide_btn = 'in'; // Está trabajando
      } else if (last.type === 'out') {
        this.screen_data.ui_hide_btn = 'out'; // No está fichado
      } else if (last.type === 'pause') {
        this.screen_data.ui_hide_btn = 'in'; // Sigue fichado, solo en pausa
      }
    } else {
      this.screen_data.ui_hide_btn = 'out';
      this.screen_data.ultimo_fichaje = null;
      this.screen_data.last_clock = null;
    }
    const now = new Date();
    const clocks = await this.repo.find_by_criteria(
      [['timestamp', '>=', startOfToday(now)]],
      ['-timestamp'],  // Orden descendente: más reciente primero, más antiguo último
      undefined,
      undefined,
      true
    );
    this.screen_data.clocks = clocks;
    const clonedClocks: Clock[] = [];

    for (const clock of this.screen_data.clocks) {
      clonedClocks.push(clock.clone());
    }

    this.screen_data.timerCounting = get_today_secs(clonedClocks);

    // Limpiar timer
    if (this.timer.t) {
      clearInterval(this.timer.t);
      this.timer.t = null;
    }
    const lastClockType = last?.type;
    const shouldStartTimer = this.screen_data.ui_hide_btn === 'in' &&
                             lastClockType !== 'pause';

    if(shouldStartTimer){
      this.timer.t = setInterval(() => {
      const clonedClocks: Clock[] = [];

      for (const clock of this.screen_data.clocks) {
        clonedClocks.push(clock.clone());
      }

        this.screen_data.timerCounting = get_today_secs(clonedClocks);
      }, this.timer_ms);
    }
    
    this.screen_data.ui_loading = false;
  }
}
